import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "container"
}
const _hoisted_2 = { class: "component-apply-button" }

import { inject, h, onBeforeUnmount, onMounted, nextTick, useSlots, ref } from 'vue';
  import { request, Modal, kakaoShare, goToLogin } from '@/utils';
  import _ from 'lodash';
  import { ISurveySection, ISurveyQuestion, ISurveryOption, ISurvey } from '@/types/survey';
  import { ColorVariants, PEOPLE_COLLECTION } from '@/constants';
  import { IProgram } from '@/types/program';
  import dayjs from 'dayjs';
  import ApplyInDialog from './apply.vue';
  import FromInDialog from './form.vue';
  import participateInDialog from './participate.vue';
  import { useRouter } from 'vue-router';
  import { authStore } from '@/stores';
  import { useI18n } from 'vue-i18n';

  export interface IProps {
    program: IProgram;
  }
export default /*#__PURE__*/_defineComponent({
  props: {
    program: null
  },
  setup(__props: any) {

const props = __props as {
    program: IProgram;
  }

  ;

  const slots = useSlots();
  const { t } = useI18n();
  const router = useRouter();
  
  let peopleCollection: PEOPLE_COLLECTION | undefined;
  let groupName: string | undefined;
  let question: ISurveyQuestion;
  const refreshPageData = (inject('refreshPageData') || _.noop) as Function;
  const buttonLoading = ref(false);

  let questions: ISurveyQuestion[] = [];
  let questionForm: {
    survey_id: number;
    type: 'CampaignResponse';
    program_id: number;
    started_at: string;
    completed_at: string;
    answers_attributes: {
      value?: string; // 简答题传
      value_type?: 'text'; // 简答题传
      survey_question_id: number;
      survey_option_ids?: number[] // 选择题传
    }[]
  };

  const handleNavToRecordDetail = () => {
    closeDialog();
    router.push({ name: 'mine.programParticipationDetail', params: { id: props.program.participation_request_id } });
  };

  const STATIC_DIALOGS = {
    ready: {
      title: t('ready_dialog_title', { name: props.program.name }),
      content: t('ready_dialog_content'),
      btns: [
        { text: t('Close'), style: ColorVariants.outlinePrimary, click: closeDialog },
        { text: t('Start'), style: ColorVariants.primary, click: nextQuestion }
      ]
    },
    confirm: {
      title: t('confirm_dialog_title'),
      content: '',
      btns: [
        { text: t('Return'), style: ColorVariants.primary, click: showFormDialog }
      ]
    },
    participated: {
      title: t('participated_dialog_title'),
      content: '',
      btns: [
        { text: t('btn_confirm'), style: ColorVariants.primary, click: closeDialog }
      ]
    },
    cancelForm: {
      title: t('cancel_dialog_title'),
      content: t('cancel_dialog_content'),
      btns: [
        { text: t('Return'), style: ColorVariants.primary, click: showFormDialog }
      ]
    },
    cancelParticipate: {
      title: t('cancel_dialog_title'),
      content: t('cancel_dialog_content'),
      btns: [
        { text: t('Return'), style: ColorVariants.primary, click: showParticipateDialog }
      ]
    },
    onMoreTime: {
      title: t('one_more_time_dialog_title'),
      content: t('one_more_time_dialog_content'),
      btns: [
        { text: t('Close'), style: ColorVariants.outlinePrimary, click: closeDialog },
        { text: t('Apply'), style: ColorVariants.primary, click: participate }
      ]
    },
    completed: {
      title: t('completed_dialog_title'),
      class: 'dialog-program-apply dialog-static-completed',
      content: t('completed_dialog_content', { name: props.program.name }),
      btns: [
        { text: t('completed_dialog_btn_1'), style: ColorVariants.primary, click: handleNavToRecordDetail },
        { text: t('completed_dialog_btn_2'), style: ColorVariants.outlinePrimary, click: handleKakaoShare },
      ]
    },
    applySuccess: {
      title: t('apply_success_dialog_title'),
      content: '',
      btns: [
        { text: t('btn_confirm'), style: ColorVariants.primary, click: closeDialog }
      ]
    },
    operationSuccess: {
      title: t('Operation success'),
      content: '',
      btns: [
        { text: t('btn_confirm'), style: ColorVariants.primary, click: closeDialog }
      ]
    }
  };

  let modal: Modal;

  onMounted(() => {
    modal = new Modal();
  });

  onBeforeUnmount(() => {
    if (modal) {
      // 如果是刚打开modal 立马关闭 遮罩会关不掉
      setTimeout(() => {
        modal.destroy();
      }, 800);
    }
  });

  const checkLogin = async () => {
    if (!authStore.isLogin) {
      closeDialog();
      const login = () => {
        closeDialog();
        goToLogin();
      };
      modal.open(
        {
          title: t('Please sign in'),
          btns: [
            { text: t('Sign in'), style: ColorVariants.primary, click: login }
          ]
        }
      );
      return false;
    }
    await authStore.tryFetchData();
    if (!_.get(authStore, 'user.profile.email_verified')) {
      const verify = () => {
        closeDialog();
        router.push({ name: 'mine.memberProfile.edit', query: { type: 'email' } });
      };
      modal.open(
        {
          title: t('verify_email_title'),
          btns: [
            { text: t('verify_email_btn'), style: ColorVariants.primary, click: verify }
          ]
        }
      );
      return false;
    }
    return true;
  };

  const checkAddress = async () => {
    await authStore.tryFetchData();
    // Apply collection之前检查是否有填写地址信息，如果没有需要redirect到 profile edit page
    if (!authStore.canParticipateProgram) {
      const navToProfileEdit = () => {
        closeDialog();
        router.push({ name: 'mine.memberProfile.edit' });
      };
      modal.open(
        {
          // TODO: 这个文案需要修改
          title: t('address_check_dialog_title'),
          btns: [
            { text: t('address_check_dialog_btn'), style: ColorVariants.primary, click: navToProfileEdit }
          ]
        }
      );
      return false;
    }
    return true;
  };

  // compaign流程
  // 1 检查collection次数
  // 2 检查show_collection_btn 为false则显示collection_btn_msg提示
  // 3 弹窗确认轮次
  // 4 点弹窗apply 执行apply
  const handleCompaginApply = async () => {
    try {
      buttonLoading.value = true;
      const logined = await checkLogin();
      if (!logined) {
        return;
      };

      const addressIsFilled = await checkAddress();
      if (!addressIsFilled) {
        return;
      }

      await refreshPageData();
      await nextTick();

      const { show_collection_btn, collection_btn_msg, name, collection_count, limit_collection_count } = props.program;

      // 如果limit_collection_count是null 表示不限制次数
      if (limit_collection_count) {
        // 没有次数了跳转到record
        if (collection_count >= limit_collection_count) {
          handleNavToRecordDetail();
          return;
        }
      }

      if (!show_collection_btn) {
        modal.open({
          title: collection_btn_msg,
          content: '',
          btns: [
            { text: t('Close'), style: ColorVariants.primary, click: closeDialog },
          ]
        });
        return;
      }
      modal.open(
        {
          title: t('apply_dialog_title', { name }),
          btns: [
            { text: t('Apply'), style: ColorVariants.primary, click: apply }
          ]
        },
        {
          default: () => [h(ApplyInDialog, { count: collection_count })]
        }
      );
    } finally {
      buttonLoading.value = false;
    }
  };

  //   ongoging流程：
  // 1. participation_request_id 为空，则调用participate接口，接口成功后返回program详情信息
  //   （1）show_collection_btn = true, 则调用collection接口
  //   （2）show_collection_btn = false，显示participation_msg
  // 2. participation_request_id 不为空，则不调用participate接口，跟第1点一样两步判断
  // 3. 直接apply
  const handleProgramApply = async () => {
    try {
      buttonLoading.value = true;

      const logined = await checkLogin();
      if (!logined) {
        return;
      };

      const addressIsFilled = await checkAddress();
      if (!addressIsFilled) {
        return;
      }

      await refreshPageData();
      await nextTick();

      // program类型没有participate按钮，但是要先生成participate记录
      if (!props.program.participation_request_id) {
        // 只调一下 不传参数
        await request.post(`programs/${props.program.id}/participate`);
        await refreshPageData();
        await nextTick();
      }

      if (props.program.show_collection_btn) {
        await apply();
        return;
      }

      modal.open({
        title: props.program.participate_btn_msg,
        content: '',
        btns: [
          { text: t('btn_confirm'), style: ColorVariants.primary, click: closeDialog },
        ]
      });
      return;
    } finally {
      buttonLoading.value = false;
    }
  };

  // 给compaign-huggies 定制的partipate
  const handleCompaignParticipateSimple = async () => {
    try {
      buttonLoading.value = true;
      const logined = await checkLogin();
      if (!logined) {
        return;
      };

      const addressIsFilled = await checkAddress();
      if (!addressIsFilled) {
        return;
      }

      await refreshPageData();
      await nextTick();

      if (!props.program.show_participate_btn) {
        modal.open({
          title: props.program.participate_btn_msg,
          content: '',
          btns: [
            { text: t('btn_confirm'), style: ColorVariants.primary, click: closeDialog },
          ]
        });
        return;
      }
      await request.post(`programs/${props.program.id}/participate`, {
        people_collection: PEOPLE_COLLECTION.individual,
        group_name: '',
      });
      refreshPageData();
      modal.open({
        title: '소중한우리아이를쓰담쓰담,\n소중한우리지구를쓰담쓰담. \n\n 맘큐에서신청하신캠페인참여정보확인후수거신청기능이활성화될예정입니다.\n(약1시간소요예정)조금만기다려주세요!',
        btns: [
          { text: '확인', style: ColorVariants.primary, click: closeDialog },
        ]
      });
    } finally {
      buttonLoading.value = false;
    }
  };

  // Apply for participate
  const handleCompaginParticipate = async () => {
    try {
      buttonLoading.value = true;
      const logined = await checkLogin();
      if (!logined) {
        return;
      };

      const addressIsFilled = await checkAddress();
      if (!addressIsFilled) {
        return;
      }

      await refreshPageData();
      await nextTick();

      if (!props.program.show_participate_btn) {
        modal.open({
          title: props.program.participate_btn_msg,
          content: '',
          btns: [
            { text: t('btn_confirm'), style: ColorVariants.primary, click: closeDialog },
          ]
        });
        return;
      }
      // 清空步骤
      peopleCollection = undefined;
      groupName = '';
      const quiz = props.program?.campaign_quiz as ISurvey;
      if (quiz) {
        const surveySections: ISurveySection[] = _.get(quiz, 'survey_sections') || [];
        questions = _.flatMap(surveySections.map(item => item.survey_questions));
        questionForm = {
          survey_id: quiz.id as number,
          type: 'CampaignResponse',
          program_id: props.program.id,
          started_at: dayjs().toISOString(),
          completed_at: '',
          answers_attributes: []
        };
        showStaticDialog('ready');
      } else {
        // 没有问卷显示选择加入类型
        showParticipateDialog();
      }
    } finally {
      buttonLoading.value = false;
    }
  };

  function handleKakaoShare() {
    return kakaoShare({
      title: props.program.share_setting?.share_title || props.program.name,
      imageUrl: props.program.share_setting?.share_image?.url || props.program.image?.url,
    });
  }

  async function apply() {
    try {
      await request.post('user_requests', {
        target_id: props.program.id,
        target_type: 'Program',
        type: 'CollectionRequest',
        people_collection: props.program.people_collection,
        group_name: props.program.group_name
      }, {
        loading: { silent: true }
      });
      await refreshPageData();
      showStaticDialog('applySuccess');
    } catch (e) {
      closeDialog();
      const errorMsg = _.get(e, 'message');
      const code = _.get(e, 'code');
      // 项目人次达到上限，需要显示错误信息并提示是否订阅 waiting list
      if (String(code) === '40008') {
        const subscribeWaitingList = async () => {
          await request.post('request_waiting_lists', {
            kind: 'collection',
            program_id: props.program.id
          });
          showStaticDialog('operationSuccess');
        };
        modal.open(
          {
            title: errorMsg,
            btns: [
              { text: t('butotn_no'), style: ColorVariants.outlinePrimary, click: closeDialog },
              { text: t('button_yes'), style: ColorVariants.primary, click: subscribeWaitingList }
            ]
          }
        );
        return;
      }
      // request.ts已经处理过这个code了
      if (String(code) !== '40305') {
        modal.open(
          {
            title: errorMsg,
            btns: [
              { text: t('btn_confirm'), style: ColorVariants.primary, click: closeDialog },
            ]
          }
        );
      }
      throw e;
    }
  }

  async function participate() {
    await request.post(`programs/${props.program.id}/participate`, {
      // 没有值表示是普通Program，默认值individual
      people_collection: peopleCollection || PEOPLE_COLLECTION.individual,
      group_name: groupName,
    });
    await refreshPageData();
    showStaticDialog('completed');
  }

  async function nextQuestion() {
    if (questions.length > questionForm.answers_attributes.length) {
      question = questions[questionForm.answers_attributes.length];
      showFormDialog();
    } else {
      // 没有下一题了
      questionForm.completed_at = dayjs().toISOString();
      await request.post('responses', questionForm);
      await refreshPageData();
      showParticipateDialog();
    }
  }

  function closeDialog() {
    modal.destroy();
    // 每次都新建一个modal，不然modal里面的slot一直没有销毁
    modal = new Modal();
  }

  function showStaticDialog(dialogName: string) {
    closeDialog();
    modal.open(STATIC_DIALOGS[dialogName]);
  }

  function showFormDialog() {
    closeDialog();
    const confirm = ({ question, option, input } : { question: ISurveyQuestion, option?: ISurveryOption, input?: string }) => {
      if (input) {
        questionForm.answers_attributes.push({
          survey_question_id: question.id as number,
          value: input,
          value_type: 'text'
        });
        return nextQuestion();
      }
      if (option) {
        if (option.is_correct) {
          questionForm.answers_attributes.push({
            survey_question_id: question.id as number,
            survey_option_ids: [option.id as number]
          });
          return nextQuestion();
        }
      }
      // 不正确
      showStaticDialog('confirm');
    };
    const cancel = () => {
      showStaticDialog('cancelForm');
    };
    modal.open(
      {
        title: question.text,
        content: '',
        btns: [],
        class: 'dialog-program-form'
      },
      {
        default: () => [h(FromInDialog, { question, onConfirm: confirm, onCancel: cancel })]
      }
    );
  }

  function showParticipateDialog() {
    closeDialog();
    const programType = props.program.type;
    const programName = props.program.name;
    // 如果是Campaign类型，
    // 流程1: "Apply for participate" => "individual" => "one more time" => "completed"
    // 流程2: "Apply for participate" => "group" => "输入group名字" => "one more time" => "completed"
    if (programType === 'Campaign') {
      const title = {
        '': t('participate_dialog_title', { name: programName }),
        [PEOPLE_COLLECTION.group]: t('participate_together', { name: programName }),
        [PEOPLE_COLLECTION.individual]: t('participate_alone', { name: programName }),
      }[peopleCollection || ''];

      const selectPeopleCollection = (peopleCollectionValue: PEOPLE_COLLECTION) => {
        peopleCollection = peopleCollectionValue;
        showParticipateDialog();
      };
      const confirm = (groupNameValue: string | undefined) => {
        groupName = groupNameValue;
        showStaticDialog('onMoreTime');
      };
      modal.open(
        {
          title,
          btns: [],
          content: '',
          class: 'dialog-participate'
        },
        {
          // FIXME: 这里没搞懂为什么类型有问题
          default: () => [h(participateInDialog as any, {
            peopleCollection,
            onSelectPeopleCollection: selectPeopleCollection,
            onConfirm: confirm,
            onCancel: () => showStaticDialog('cancelParticipate')
          })]
        }
      );
    } else {
      // 如果是普通program，people_collection 默认是individual
      // 流程:  "Apply for participate" => "one more time" => "completed"
      showStaticDialog('onMoreTime');
    }
  }

return (_ctx: any,_cache: any) => {
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!

  return (_unref(slots).default)
    ? _renderSlot(_ctx.$slots, "default", {
        key: 0,
        simpleParticipate: handleCompaignParticipateSimple,
        participate: handleCompaginParticipate,
        apply: __props.program.type === 'Campaign' ? handleCompaginApply : handleProgramApply,
        loading: buttonLoading.value
      })
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (__props.program.type === 'Campaign')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_AppLoadingButton, {
                  pill: "",
                  variant: _unref(ColorVariants).outlinePrimary,
                  class: "apply-button",
                  onClick: handleCompaginParticipate
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('Apply for participate')), 1)
                  ]),
                  _: 1
                }, 8, ["variant"]),
                _createVNode(_component_AppLoadingButton, {
                  pill: "",
                  variant: _unref(ColorVariants).primary,
                  class: "apply-button",
                  onClick: handleCompaginApply
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('Apply for collection')), 1)
                  ]),
                  _: 1
                }, 8, ["variant"])
              ], 64))
            : (_openBlock(), _createBlock(_component_AppLoadingButton, {
                key: 1,
                pill: "",
                variant: _unref(ColorVariants).primary,
                class: "apply-button",
                onClick: handleProgramApply
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('Apply for collection')), 1)
                ]),
                _: 1
              }, 8, ["variant"]))
        ])
      ]))
}
}

})